module.exports = __webpack_public_path__ + "img/google-marker.0cf30e06.png";